import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { homePathForRole, loginPathForRole, isRoleAllowed } from "@/lib/roleRouter";

/**
 * Route middleware — enforces the cross-role access rules from Prompt 1
 * (Multi-Role Auth). Wraps every authenticated route in `App.js`.
 *
 * Unauth  → send to the role-appropriate login page.
 * Wrong-role → send back to the user's own home dashboard (never leak a
 *              403; the router just quietly redirects).
 */
export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const redirectState = useMemo(() => ({ from: location.pathname }), [location.pathname]);

  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="overline">Loading…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to={loginPathForRole(role)} state={redirectState} replace />;
  }
  if (!isRoleAllowed(role, user.role)) {
    return <Navigate to={homePathForRole(user.role)} replace />;
  }
  return children;
}
